import React from "react";

const Result = ({ req, index, data, getDropOff, avatar, calendar }) => {
  // console.log("dataaaaa" ,data);
  return (
    <div key={index}>
      <h6 className="py-2">{req}</h6>
      {data.map((datum, index) => {
        return (
          <div key={index}>
            <div className="reqBg">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="d-flex align-items-center">
                    <img src={avatar} alt={avatar} />
                    <p className="mb-0 ml-2">{datum?.owner?.name}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="d-flex">
                    <div>
                      <img src={calendar} alt={calendar} />
                    </div>
                    <p className="mb-0 ml-2" style={{ fontSize: "13px" }}>
                      {datum.date_type}
                    </p>
                  </div>
                  <div className="ml-2">
                    <div
                      className="buttonLike"
                      style={{ cursor: "pointer" }}
                      onClick={() => getDropOff(datum.code)}
                    >
                      <span
                        style={{
                          color: "#fff",
                          textAlign: "center",
                          margin: "auto",
                        }}
                      >
                        &#62;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Result;
